<template>
  <div>
    <div v-if="isVerified">
      <div class="has-text-centered membership-header">
        <h1 class="is-size-5 has-text-weight-bold">{{ $t('description.emailVerified') }}.</h1>
        <h2 class="is-size-6">{{ $t('description.canLoginWithEmailAndPassword') }}</h2>
      </div>
      <div class="field is-grouped is-grouped-centered">
        <router-link class="button is-vcentered is-primary login-button" :to="{ name: 'login' }">
          <strong>{{ $t('button.login') }}</strong>
        </router-link>
      </div>
    </div>
    <div v-else-if="isVerified === false">
      <div class="has-text-centered membership-header">
        <h1 class="is-size-5 has-text-weight-bold">{{ $t('description.emailNotVerified') }}.</h1>
        <h2 class="is-size-6">{{ $t('description.pleaseTryAgain') }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../_api/api.service'

export default {
  data() {
    return {
      isVerified: null
    }
  },
  mounted() {
    const { token } = this.$route.query
    if (!token) {
      this.$router.push({ name: 'login' })
    } else {
      ApiService.post('/auth/verify', { token }).then(data => {
        this.isVerified = data.isValid
      })
    }
  }
}
</script>
